import { Box, Button, LinearProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import AddIcon from '@mui/icons-material/Add'
import { coursePromotionApi } from '../../../../../../features/course/coursePromotion'
import { CoursePromotionState } from '../../../../../../features/types'
import PromoDialog from '../components/PromoDialog'
import PromoTable from '../components/PromoTable'

interface Props {
    coursePriceId: number
}

const styles = {
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
}

const PromoTab: React.FC<Props> = ({ coursePriceId }) => {
    const { formatMessage } = useIntl()
    const [openPromoDialog, setOpenPromoDialog] = useState<boolean>(false)
    const [currentRowData, setCurrentRowData] =
        useState<CoursePromotionState>(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)

    const { data: promotionResponse = null, isFetching } =
        coursePromotionApi.useGetPromotionsByCoursePriceQuery(
            {
                coursePriceId,
                page: +page,
                size: +rowsPerPage,
            },
            {
                skip: !coursePriceId,
            },
        )
    const [deletePromotion, { isLoading: isDeleting }] =
        coursePromotionApi.useDeleteCoursePromotionMutation()
    const isLoading = isFetching || isDeleting

    const handleRowUpdate = (row: CoursePromotionState) => {
        setCurrentRowData(row)
        setOpenPromoDialog(true)
    }

    const handleDelete = async (id: number) => {
        try {
            await deletePromotion(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {}
    }

    useEffect(() => {
        if (!openPromoDialog) {
            setCurrentRowData(null)
        }
    }, [openPromoDialog])

    return (
        <Box sx={styles.flexColumn}>
            <Box
                ml="auto"
                mb={2}
            >
                <Button
                    onClick={() => setOpenPromoDialog(true)}
                    variant="contained"
                    endIcon={<AddIcon />}
                >
                    {formatMessage({ id: 'addPromo' })}
                </Button>
            </Box>
            
            {isLoading ? (
                <LinearProgress />
            ) : (
                promotionResponse && (
                    <PromoTable
                        promotions={promotionResponse.data}
                        pageNumber={promotionResponse.pageNumber}
                        totalCount={promotionResponse.totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        isFetching={isFetching}
                        setPage={setPage}
                        setRowsPerPage={setRowsPerPage}
                        onDelete={handleDelete}
                        onEdit={handleRowUpdate}
                    />
                )
            )}

            <PromoDialog
                coursePriceId={coursePriceId}
                open={openPromoDialog}
                editPromo={currentRowData}
                handleClose={() => setOpenPromoDialog(false)}
            />
        </Box>
    )
}

export default PromoTab
